export default __webpack_public_path__ + "static/media/BrainBreak cards81.9880ba1d.png";